import React, { Component } from "react";
import SubNav from "../../../shared/subnav/SubNav";
import { withTranslation } from "react-i18next";
import HasPermissionTo from "../../../common/HasPermissionTo";
import styles from "./DashboardStyles.module.scss";
import DealerReporting from "./DealerReporting/DealerReporting";
import PendingActions from "../pendingActions/PendingActions";
import DealerNotifications from "../dealerNotifications/DealerNotifications";
import { displayError, LOAD_ERROR } from "../../../errors/ErrorConstants";
import DealerAnnouncement from "../annoucements/DealerAnnouncement";
import ConfirmDialog from "../../../shared/confirmDialog/ConfirmDialog";
import VehicleCatalogClient from "../../../shared/clients/VehicleCatalogClient";
import OrderUpdateNotifications from "../orderNotifications/OrderUpdateNotifications";
import HandOverNotifications from "../handOverNotifications/HandOverNotifications";

class DealerDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
      renderApp: false,
      hasError: [],
      confirmDialog: false,
      confirmDialogProps: {},
    };
  }

  componentDidMount() {
    try {
      this.props.user.dashboardPage
        ? this.setState({ selectedTab: this.props.user.dashboardPage })
        : this.updateDashboardTab(this.state.selectedTab);
      this.setState({ renderApp: true });
      this.fetchVehicleStatuses();
    } catch (e) {
      this.setState({ hasError: [LOAD_ERROR] });
    }
  }

  handleTabChange = (event, selectedTab) => {
    this.updateDashboardTab(selectedTab);
    this.setState({ selectedTab });
  };

  handleOnConfirm = () => {
    this.setState({ confirmDialog: false });
    this.props.toggleFirstTimeLoadingApp();
  };

  handleOnCancel = () => {
    this.setState({ confirmDialog: false });
  };

  fetchVehicleStatuses = () => {
    VehicleCatalogClient.getStatusOverviewTable(this.props.user)
      .then((response) => {
        this.generateConfirmDialogProps(response);
        this.setState({ renderApp: true });
      })
      .catch(() => this.setState({ renderApp: true }));
  };

  generateConfirmDialogProps = (response) => {
    const nonPricedVehicles = [];
    response &&
      response.forEach((vehicleLine) => {
        if (
          vehicleLine &&
          vehicleLine.currentYearStatus &&
          !vehicleLine.currentYearStatus.status
        ) {
          nonPricedVehicles.push(
            "\n" + vehicleLine.currentYearStatus.year + " " + vehicleLine.model
          );
        }
        if (
          vehicleLine &&
          vehicleLine.previousYearStatus &&
          !vehicleLine.previousYearStatus.status
        ) {
          nonPricedVehicles.push(
            "\n" + vehicleLine.previousYearStatus.year + " " + vehicleLine.model
          );
        }
      });

    if (nonPricedVehicles.length > 0) {
      this.setState({
        confirmDialog: true,
        confirmDialogProps: {
          title: this.props.t("DealerDashboard.itemsToBePricedDialogTitle", {
            numItems: nonPricedVehicles.length,
          }),
          bodyText: this.props.t("DealerDashboard.itemsToBePricedDialogBody", {
            outstandingPricingItems: nonPricedVehicles,
          }),
          confirm: this.props.t("GeneralEMP.confirm"),
        },
      });
    }
  };

  updateDashboardTab = (selectedTab) => {
    this.props.user.updateDashboardTab &&
      this.props.user.updateDashboardTab(selectedTab);
  };

  getTabs() {
    const tabs = [];

    tabs.push({
      menuName: this.props.t("ProgressBar.notifications"),
      enabled: true,
      id: "dashboard",
    });
    this.props.user.userType === "dealer" &&
      tabs.push({
        menuName: this.props.t("ProgressBar.reporting"),
        enabled: true,
        id: "reporting",
      });
    return tabs;
  }

  render() {
    if (displayError(this.state.hasError))
      throw new Error(this.state.hasError[0]);

    return (
      this.state.renderApp && (
        <div id="dashboard" className="pageWrapper">
          <HasPermissionTo
            perform={["dealerReporting:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            render={() => {
              return (
                <SubNav
                  dashboard={true}
                  selectedTab={this.state.selectedTab}
                  title={this.props.t("GlobalNavBar.dashboard")}
                  action={this.handleTabChange}
                  tabs={this.getTabs()}
                  {...this.props}
                />
              );
            }}
            noRender={() => {
              return (
                <SubNav
                  id="subNav"
                  dashboard={true}
                  title={this.props.t("GlobalNavBar.dashboard")}
                  {...this.props}
                />
              );
            }}
          />
          <div className={styles.wrapper}>
            <DealerAnnouncement {...this.props} />
          </div>
          {this.state.selectedTab === 0 ? (
            <>
              <div className={styles.wrapper}>
                <HasPermissionTo
                  perform={["pendingActionQueue:view"]}
                  permissions={this.props.user.permissions.rolePermissions}
                  render={() => <PendingActions {...this.props} />}
                />
              </div>
              <div className={styles.wrapper}>
                <HasPermissionTo
                  perform={["notificationsQueue:view"]}
                  permissions={this.props.user.permissions.rolePermissions}
                  render={() => <DealerNotifications {...this.props} />}
                />
              </div>
              <div className={styles.wrapper}>
                <HasPermissionTo
                  perform={["orderUpdateNotifications:view"]}
                  permissions={this.props.user.permissions.rolePermissions}
                  render={() => <OrderUpdateNotifications {...this.props} />}
                />
              </div>
              <div className={styles.wrapper}>
                <HasPermissionTo
                  perform={["handOverNotifications:view"]}
                  permissions={this.props.user.permissions.rolePermissions}
                  render={() => <HandOverNotifications {...this.props} />}
                />
              </div>
            </>
          ) : (
            <HasPermissionTo
              perform={["dealerReporting:view"]}
              permissions={this.props.user.permissions.rolePermissions}
              condition={this.state.selectedTab === 1}
              render={() => <DealerReporting {...this.props} />}
            />
          )}
          <ConfirmDialog
            open={this.state.confirmDialog && this.props.firstTimeLoadingApp}
            showWarningIcon={true}
            boldTitle={true}
            dialogProps={this.state.confirmDialogProps}
            onCancel={this.handleOnCancel}
            onConfirm={this.handleOnConfirm}
            showOneButton={true}
            {...this.props}
          />
        </div>
      )
    );
  }
}

export default withTranslation("emp")(DealerDashboard);
